import { render } from "./bond_level_edit.vue?vue&type=template&id=0b562689"
import script from "./bond_level_edit.vue?vue&type=script&lang=js"
export * from "./bond_level_edit.vue?vue&type=script&lang=js"
script.render = render

export default script